export default __webpack_public_path__ + "static/media/Discord.4c6c8ab4.svg";